import { environmentPreferences } from "@/utils/environmentPreferences";

export function createFormStylingPreferences(storage = environmentPreferences) {
  const read = (key) => {
    try {
      return JSON.parse(storage.getItem(key));
    } catch {
      return null;
    }
  };

  return {
    saveGroupPreferences(groups) {
      const configGroups = {};
      for (const [key, group] of Object.entries(groups)) {
        configGroups[key] = { enabled: group.enabled, applyTo: group.applyTo };
      }
      storage.setItem("formStylingGroupPreferences", JSON.stringify({ configGroups }));
    },
    loadGroupPreferences(groups) {
      const saved = read("formStylingGroupPreferences")?.configGroups;
      if (!saved || typeof saved !== "object") return;
      for (const [key, group] of Object.entries(groups)) {
        const preference = saved[key];
        if (!preference || typeof preference !== "object") continue;
        if (typeof preference.enabled === "boolean") {
          group.enabled = preference.enabled;
        }
        if (Array.isArray(preference.applyTo?.devices) && Array.isArray(preference.applyTo?.modes)) {
          group.applyTo = {
            devices: [...preference.applyTo.devices],
            modes: [...preference.applyTo.modes],
          };
        }
        // Colors, layouts and texts always come from the API, not browser state.
      }
    },
    loadTemplates() {
      const saved = read("formStylingTemplates");
      return Array.isArray(saved) ? saved : [];
    },
    saveTemplates(templates) {
      storage.setItem("formStylingTemplates", JSON.stringify(templates));
    },
  };
}

export const formStylingPreferences = createFormStylingPreferences();
